/* eslint-disable */
import sandeep from "../assets/svg/testimonials/sandeep.png";
import nitin from "../assets/svg/testimonials/Nitin.png";
import Junaid from "../assets/svg/testimonials/Junaid.png";
import girl3 from "../assets/svg/testimonials/girl3.svg";
import ripesh from "../assets/svg/testimonials/Ripesh.png";
import boy1 from "../assets/svg/testimonials/boy2.svg";


export const testimonialsData = [
  {
    id: 1,
    name: "Ripesh Raushan Singh",
    title:
      "Working at Polycab, Ex-Intern at Tata Motors, Flipkart, Mahindra, wipro, Zomato and Whitehat Jr ",
    text: "There is no better colleague than Simrat. he is one of the most dedicated professionals I’ve worked with and is willing to put that extra help whenever you need it. His expertise as a developer is considerable and I highly recommend Simrat.",
    image: ripesh,
  },
  {
    id: 2,
    name: "Nitin Sinha",
    title: "SDE at Kindlife",
    text: "Simrat is a hardworking guy who is also good in his technical skills and takes his work with upmost responsibility. He is very adaptable with the conditions and a solution oriented person.",
    image: nitin,
  },
  {
    id: 3,
    name: "Sandeep kaur",
    title: "Assistant Professor @LPU | Epam Trainer",
    text: "Simrat is a talented web developer with a keen eye for design and an excellent grasp of user experience. He has a proven track record of creating visually stunning and responsive websites that are both engaging and easy to navigate. I highly recommend him, and I'm confident he will be an asset to any team he joins.",
    image: sandeep,
  },
  {
    id: 4,
    name: "Vaisshalli Gopirekha",
    title: "Full stack web developer at Blu Ocean",
    text: "One of the best colleague we have ever had and he is a hard working individual. Simrat is a real experienced professional in web development . He is a self motivated and forward thinking individual. He is outstanding in his field and easy to work with. It was super cool working with him!!",
    image: girl3,
  },
  {
    id: 5,
    name: "Mir Junaid Rasool",
    title: "Assistant Professor @LPU | Epam Trainer",
    text: "Simrat consistently demonstrated a strong work ethic, a positive attitude, and a commitment to their academic and personal growth. I highly recommend him for any opportunity they may pursue and wish them all the best in their future endeavors.",
    image: Junaid,
  },
];
